/* -- Generated File: Do Not Edit ------------------------------------------ */
export const spacings = {
  space0: '4px',
  space1: '8px',
  space2: '12px',
  space3: '16px',
  space4: '20px',
  space5: '24px',
  space6: '32px',
  space7: '48px',
  space8: '80px',
  space9: '144px',
};

export default spacings;
/* -- Generated File: Do Not Edit ------------------------------------------ */
